import PropTypes from 'prop-types';
import React from 'react';
import TourHotelRouteList from './TourHotelRouteList';
import GroupsHotelPickerContainer from './GroupsHotelPickerContainer';
import HotelSearchPrefsContainer from './HotelSearchPrefsContainer';

function findEvent(value) {
  // do not use === here, matches a string and a number
  return value.id == this; // eslint-disable-line
}
function showPrefs(groups) {
  for (let i = 0, len = groups.length; i < len; i++) {
    if (!groups[i].hotel_prefs.has_search_prefs) {
      return true;
    }
  }
  return false;
}
class TourHotelSelectTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      event: null,
    };
    this.setCurrentEvent = this.setCurrentEvent.bind(this);
    this.handleClosePrefs = this.handleClosePrefs.bind(this);
    this.handleShowPrefs = this.handleShowPrefs.bind(this);
  }
  componentWillMount() {
    this.setState({ show: showPrefs(this.props.tour.groups) });
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedEvent !== this.props.selectEvent) {
      const event = nextProps.tour.tour_stops.find(findEvent, nextProps.selectedEvent);
      this.setState({ event });
    }
  }
  setCurrentEvent(id) {
    this.props.selectEvent(id);
  }
  handleClosePrefs() {
    this.setState({ show: false });
  }
  handleShowPrefs() {
    this.setState({ show: true });
  }
  render() {
    return (
      <div>
        <div className="bid-panel">
          <HotelSearchPrefsContainer
            groups={this.props.tour.groups}
            show={this.state.show}
            onClose={this.handleClosePrefs}
          />
          <TourHotelRouteList
            routes={this.props.tour.tour_stops}
            selectedRoute={this.state.event}
            selectRoute={this.setCurrentEvent}
            showPrefs={this.handleShowPrefs}
          />
        </div>
        <GroupsHotelPickerContainer
          groups={this.props.tour.groups}
          selectedEvent={this.state.event}
          showPrefs={this.handleShowPrefs}
        />
      </div>
    );
  }
}
TourHotelSelectTab.propTypes = {
  tour: PropTypes.object.isRequired,
  selectedEvent: PropTypes.number, // eslint-disable-line
  selectEvent: PropTypes.func.isRequired,
};
TourHotelSelectTab.defaultProps = {
  selectedEvent: null,
};

export default TourHotelSelectTab;



// WEBPACK FOOTER //
// src/routes/tours/components/TourHotelSelectTab.js